import React, { useState, useEffect } from "react";
import axios from "axios";

const EventList = ({ selectedDate }) => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        axios
            .get("http://snmsangli.com/api/event/get_event") 
            .then((response) => {
                const eventData = response.data;

                const formattedSelectedDate = selectedDate
                    .toISOString()
                    .split('T')[0];

                const formattedEvents = eventData.map((event) => ({
                    ...event,
                    event_date: event.event_date
                        .split('-')
                        .reverse()
                        .join('-'), 
                }));

                const filteredEvents = formattedEvents.filter(
                    (event) => event.event_date === formattedSelectedDate
                );

                setEvents(filteredEvents);
            })
            .catch((error) => {
                console.error("Error fetching events data:", error);
            });
    }, [selectedDate]);

    return (
        <div>
            {events.length === 0 ? (
              <div className="">
                  <p className="p-3 text-base text-center text-blue-900">No events for This date</p>
                <img src="./image/noEvents3.gif" width={250} alt="img" className="animate-pulse"/>
              </div>
            ) : (
                <div>
                    {events.map((event) => (
                        <div key={event.id}>
                            <div className="flex">
                                <p className="px-4 py-4 text-xl font-semibold">Event Date  :</p> <p className="py-4 text-lg font-medium ">{event.event_date}</p>
                            </div>
                            <div className="flex">
                            <p className="px-4 py-1 text-xl font-semibold">Event Name  : </p> <p className="py-1 text-lg font-medium ">{event.event_name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default EventList;
